export const ADD_TAGS_SUCCESS = "ADD_TAGS_SUCCESS";
export const ADD_TAGS_REQUEST = "ADD_TAGS_REQUEST";
export const ADD_TAGS_FAILURE = "ADD_TAGS_FAILURE";
export const ADD_TAGS_RESET = "ADD_TAGS_RESET";
export const addTagsSuccess = (payload) => ({
    type: ADD_TAGS_SUCCESS,
    payload,
});
export const addTagsRequest = (payload) => ({
    type: ADD_TAGS_REQUEST,
    payload,
});
export const addTagsFailure = (payload) => ({
    type: ADD_TAGS_FAILURE,
    payload,
});
export const addTagsReset = () => ({
    type: ADD_TAGS_RESET,
});
